export default "__VITE_ASSET__BFUdpExs__"